export default __webpack_public_path__ + "static/media/ModbusMeter.a7048630.svg";